<div class="flex flex-col h-full"
     data-test="certificate-container"
     [formGroup]="metaDataForm"
>

  <section class="detailview-summary"
           data-test="certificate-summary"
  >
    <p class="detailview-summary-name"
       data-test="certificate-summary-name"
    >
      {{ certificateTitle() || 'My Certificate' }}
    </p>
    <p class="detailview-summary-meta">
      <span class="detailview-summary-meta-label">Certificate-ID: </span>
      <span class="detailview-summary-meta-value"
            data-test="certificate-id-summary"
      >
        {{ certificateId() || '-' }}
      </span>
    </p>
  </section>

  <div class="detailview-toolbar md:pl-4 md:pr-4 sticky z-13">
    <div class="detailview-toolbar-inner flex gap-2 p-4 bg-white rounded-md border border-gray-300">
      <albert-section-navigation [sectionControl]="sectionControl"/>
      @if (isCreateMode()) {
        <div class="actions-row flex justify-end gap-2 ml-auto flex-wrap">
          <button pButton
                  type="button"
                  data-test="save-button"
                  severity="success"
                  [disabled]="isSaveDisabled()"
                  (click)="onSave()"
          >
            <i class="pi pi-save"></i>
            Speichern
          </button>
        </div>
      }
    </div>
  </div>

  <div class="md:p-4 pt-4 mx-auto w-full grow">
    <p-accordion data-test="certificate-accordion"
                 [multiple]="true"
                 [value]="nav.activePanels()"
                 (valueChange)="nav.setActivePanels($event)"
    >
      <p-accordion-panel data-test="accordion-panel-comments"
                         value="0"
      >
        <div #accordionPanel
             class="accordion-panel-scroll-target"
             [attr.data-index]="nav.getSectionIndex(0)"
        ></div>
        <p-accordion-header data-test="accordion-header-comments">
          <p class="section-title certificate-headline">Comments</p>
        </p-accordion-header>

        <p-accordion-content data-test="accordion-content-comments">
          @if (nav.activePanels().includes('0')) {
            <div class="comparison-grid expanded-mode"
                 data-test="certificate-meta-data-comments-comparison-grid"
                 [formGroup]="metaDataForm"
            >
              <div>
                <albert-textarea data-test="certificate-internal-comment"
                                 groupName="internalComment"
                                 inputId="internalComment"
                                 [disabled]="!canEdit()"
                                 [label]="'Internal Comment'"
                                 [rows]="8"
                />
              </div>
              <div class="override-cell">
                <albert-textarea data-test="certificate-external-comment"
                                 groupName="externalComment"
                                 inputId="externalComment"
                                 [disabled]="!canEdit()"
                                 [label]="'External Comment'"
                                 [rows]="8"
                />
              </div>
            </div>
          }
        </p-accordion-content>
      </p-accordion-panel>

      <p-accordion-panel data-test="accordion-panel-certificate-details"
                         value="1"
      >
        <div #accordionPanel
             class="accordion-panel-scroll-target"
             [attr.data-index]="nav.getSectionIndex(1)"
        ></div>
        <p-accordion-header data-test="accordion-header-certificate-details">
          <p class="section-title certificate-headline">Certificate Details</p>
        </p-accordion-header>

        <p-accordion-content data-test="accordion-content-certificate-details">
          @if (nav.activePanels().includes('1')) {
            <albert-certificate-details [form]="certificateDetailsForm"
                                        [metaDataForm]="metaDataForm"
                                        [periodForm]="periodForm"
                                        [periodOptions]="periodOptions()"
                                        [policyForm]="policyForm"
                                        [policyOptions]="policyOptions()"
            />
          }
        </p-accordion-content>
      </p-accordion-panel>

      <p-accordion-panel data-test="accordion-panel-certificate-contract-details"
                         value="2"
      >
        <div #accordionPanel
             class="accordion-panel-scroll-target"
             [attr.data-index]="nav.getSectionIndex(2)"
        ></div>
        <p-accordion-header data-test="accordion-header-certificate-contract-details">
          <p class="section-title certificate-headline">Contract Details</p>
        </p-accordion-header>

        <p-accordion-content data-test="accordion-content-certificate-contract-details">
          @if (nav.activePanels().includes('2')) {
            <albert-certificate-contract-details [form]="contractDetailsForm"
                                                [insuredUuid]="insuredUuid()"
                                                [periodUuid]="periodUuid()"
            />
          }
        </p-accordion-content>
      </p-accordion-panel>

      @if (categoryService.activeCertificateCategory() !== CertificateCategory.LSG) {
        <p-accordion-panel data-test="accordion-panel-certificate-hull-cover-provisions"
                           value="3"
        >
          <div #accordionPanel
               class="accordion-panel-scroll-target"
               [attr.data-index]="nav.getSectionIndex(3)"
          ></div>
          <p-accordion-header data-test="accordion-header-certificate-hull-cover-provisions">
            <p class="section-title certificate-headline">Hull and Spares Cover & Provisions</p>
          </p-accordion-header>

          <p-accordion-content data-test="accordion-content-certificate-hull-cover-provisions">
            @if (nav.activePanels().includes('3')) {
              <albert-hull-spares-cover-provisions [fleetListAsAttachmentLocked]="manager.fleetListAsAttachmentLocked()"
                                            [form]="hullSparesCoverProvisionsForm"
                                            [policyId]="policyForm.controls.uuid.value"
              />
            }
          </p-accordion-content>
        </p-accordion-panel>
      }

      <p-accordion-panel data-test="accordion-panel-certificate-liability-cover-provisions"
                         value="4"
      >
        <div #accordionPanel
             class="accordion-panel-scroll-target"
             [attr.data-index]="nav.getSectionIndex(4)"
        ></div>
        <p-accordion-header data-test="accordion-header-certificate-liability-cover-provisions">
          <p class="section-title certificate-headline">Liability Cover & Provisions</p>
        </p-accordion-header>

        <p-accordion-content data-test="accordion-content-certificate-liability-cover-provisions">
          @if (nav.activePanels().includes('4')) {
            <albert-liability-cover-provisions [form]="liabilityCoversProvisionsForm"/>
          }
        </p-accordion-content>
      </p-accordion-panel>

      <p-accordion-panel data-test="accordion-panel-certificate-final-provisions"
                         value="5"
      >
        <div #accordionPanel
             class="accordion-panel-scroll-target"
             [attr.data-index]="nav.getSectionIndex(5)"
        ></div>
        <p-accordion-header data-test="accordion-header-certificate-liability-final-provisions">
          <p class="section-title certificate-headline">Final Provisions</p>
        </p-accordion-header>

        <p-accordion-content data-test="accordion-content-certificate-liability-final-provisions">
          @if (nav.activePanels().includes('5')) {
            <albert-final-provisions [form]="finalProvisionsForm"/>
          }
        </p-accordion-content>
      </p-accordion-panel>

      <p-accordion-panel data-test="accordion-panel-certificate-holder"
                         value="6"
      >
        <div #accordionPanel
             class="accordion-panel-scroll-target"
             [attr.data-index]="nav.getSectionIndex(6)"
        ></div>
        <p-accordion-header data-test="accordion-header-certificate-holder">
          <p class="section-title certificate-headline">Certificate Holder (CH)</p>
        </p-accordion-header>

        <p-accordion-content data-test="accordion-content-certificate-holder">
          @if (nav.activePanels().includes('6')) {
            <albert-certificate-certificate-holder [certificateHolders]="manager.certificateHolders"
                                                   (addHolderWithoutEmails)="manager.addCertificateHolderWithoutEmails($event)"
                                                   (addSingleEmail)="manager.addCertificateHolderSingleEmail($event)"
                                                   (removeAddress)="manager.removeCertificateHolderAddress($event)"
                                                   (removeHolder)="manager.removeCertificateHolder($event)"
            />
          }
        </p-accordion-content>
      </p-accordion-panel>

      <p-accordion-panel data-test="accordion-panel-certificate-additional-recipients"
                         value="7"
      >
        <div #accordionPanel
             class="accordion-panel-scroll-target"
             [attr.data-index]="nav.getSectionIndex(7)"
        ></div>
        <p-accordion-header data-test="accordion-header-certificate-additional-recipients">
          <p class="section-title certificate-headline">Additional Certificate Recipients (ACR)</p>
        </p-accordion-header>

        <p-accordion-content data-test="accordion-content-certificate-additional-recipients">
          @if (nav.activePanels().includes('7')) {
            <albert-certificate-acr [additionalCertificateRecipients]="manager.additionalCertificateRecipients"
                                    (addRecipientWithoutEmails)="manager.addAcrWithoutEmails($event)"
                                    (addSingleRecipientEmail)="manager.addAcrSingleEmail($event)"
                                    (removeRecipient)="manager.removeAcr($event)"
                                    (removeRecipientAddress)="manager.removeAcrAddress($event)"
            />
          }
        </p-accordion-content>
      </p-accordion-panel>

      <p-accordion-panel data-test="accordion-panel-certificate-documents"
                         value="8"
      >
        <div #accordionPanel
             class="accordion-panel-scroll-target"
             [attr.data-index]="nav.getSectionIndex(8)"
        ></div>
        <p-accordion-header data-test="accordion-header-certificate-documents">
          <p class="section-title certificate-headline">Documents</p>
        </p-accordion-header>

        <p-accordion-content data-test="accordion-content-certificate-documents">
          @if (nav.activePanels().includes('8')) {
            <albert-certificate-documents [documents]="manager.documents"/>
          }
        </p-accordion-content>
      </p-accordion-panel>
    </p-accordion>
    <p-divider/>
    <div>
      <albert-certificate-meta-data [form]="metaDataForm"/>
    </div>
  </div>
</div>
